// extracted by mini-css-extract-plugin
module.exports = {"no-followings":"MyFollowingsModal_no-followings__395I7","followings-container":"MyFollowingsModal_followings-container__2J2j3"};